module.exports = __webpack_public_path__ + "static/media/PradeepRathi.35cfa970.png";